import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { offersAPI } from '../api/client'

interface OfferModalProps {
  listingId: number
  currentPrice: number
  isOpen: boolean
  onClose: () => void
  token: string
  /** Stack above listing detail overlay */
  overlayClassName?: string
  onSubmitted?: () => void
}

export default function OfferModal({
  listingId,
  currentPrice,
  isOpen,
  onClose,
  token,
  overlayClassName,
  onSubmitted,
}: OfferModalProps) {
  const { t } = useTranslation()
  const [offeredPrice, setOfferedPrice] = useState(currentPrice * 0.9)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setOfferedPrice(Number((currentPrice * 0.9).toFixed(2)))
    }
  }, [isOpen, currentPrice, listingId])

  function submitOffer() {
    if (!Number.isFinite(offeredPrice) || offeredPrice <= 0) {
      alert(t('offer.invalidPrice'))
      return
    }

    setLoading(true)
    offersAPI
      .createOffer({ listing_id: listingId, offered_price: offeredPrice }, token)
      .then(() => {
        alert(t('offer.submitted'))
        onClose()
        onSubmitted?.()
      })
      .catch((err) =>
        alert(`${t('common.error')}: ${err.response?.data?.detail || err.message}`),
      )
      .finally(() => setLoading(false))
  }

  if (!isOpen) return null

  const discountPct =
    currentPrice > 0 ? ((1 - offeredPrice / currentPrice) * 100).toFixed(1) : '0.0'

  return (
    <div className={`modal-overlay${overlayClassName ? ` ${overlayClassName}` : ''}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>{t('offer.title')}</h3>
        <label>
          {t('offer.price')}
          <input
            type="number"
            step="0.01"
            value={offeredPrice}
            onChange={(e) => setOfferedPrice(parseFloat(e.target.value))}
          />
        </label>
        <p className="discount">
          {t('offer.discount')}: {discountPct}%
        </p>
        <div className="modal-buttons">
          <button onClick={onClose} className="btn-secondary">
            {t('common.cancel')}
          </button>
          <button onClick={submitOffer} disabled={loading} className="btn-primary">
            {loading ? t('offer.sending') : t('offer.submit')}
          </button>
        </div>
      </div>
    </div>
  )
}
